//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('coopLangs', {
//        templateUrl: 'views/components/views/coopLangs/coopLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'coopLangsService', function ($stateParams, stateService, coopLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let coopId = $stateParams.coop_id;
            
//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await coopLangsService.listCoopLanguages({ coop_id: coopId });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                coopLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    stateService.back();
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
